/* eslint-disable */
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const ComplaintDisputeChart = ({ pieData = [0, 0], labelsData=[]}) => {
  const pieChartData = {
    // labels: ['Closed as per business instructions', 'Oppositions Closed'],
    labels: labelsData,
    datasets: [
      {
        data: pieData,
        backgroundColor: ['#c9def4', '#1e3361'],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const commonLegend = {
    display: true,
    position: 'bottom',
    labels: {
      usePointStyle: true,
      pointStyle: 'rectRounded',
      color: '#000',
      font: {
        family: 'sans-serif',
        size: 13,
      },
    },
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: commonLegend,
    },
  };

  return (
        <div
            style={{display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  gap: '16px',
  width: '100%',
  flexWrap: 'wrap'}}
        >
            <Pie data={pieChartData} options={pieOptions} />
        </div>
        
    );
};

export default ComplaintDisputeChart;